module.exports = __webpack_public_path__ + "img/Lputih.5e5155b1.svg";